import '../javascript/shared/jquery_global'

import '../javascript/shared/libraries'
import '../javascript/admin/form';
import * as Routes from "../javascript/shared/routes";
window.AdminRoutes = Routes;
import '../javascript/shared/mdm'
import '../javascript/admin/turbolinks'
import ReactRailsUJS from 'react_ujs';
import Turbolinks from 'turbolinks';
import { logs } from '../javascript/ajax_clients';
import { createComponentContext } from '../javascript/shared/vite_component_context'
const componentModules = import.meta.glob(
  [
    '../javascript/components/**/*.{js,jsx,ts,tsx}',
    '!../javascript/components/**/*.{test,spec}.{js,jsx,ts,tsx}',
  ],
  { eager: true },
)
const componentRequireContext = createComponentContext(componentModules, '../javascript/components/')
ReactRailsUJS.useContext(componentRequireContext);
// react_ujs's detectEvents() runs as an import-time side effect of importing
// react_ujs, and it looks for a bare global `Turbolinks` to decide which
// events to bind to. Vite's chunk-splitting can put that side effect ahead
// of this file's own code in execution order (verified in the production
// bundle), so relying on import order to expose the global first isn't
// reliable. Instead, explicitly re-run detectEvents() after making
// Turbolinks available globally - detectEvents() is designed to be safely
// re-callable and tears down/re-binds whatever it set up the first time.
window.Turbolinks = Turbolinks;
ReactRailsUJS.detectEvents();

window.onerror = function(message, source, lineNumber, columnNumber, e) {
    const error = e == null ? null : {
        message: e.message,
        name: e.name,
        stack: e.stack && e.stack.substring ? e.stack.substring(0, 50000) : e.stack,
    };
    logs.error(message, {source, lineNumber, columnNumber, error});
    return false; // let the error propogate as normal
}
